import { BlankByBlankGrading, Response } from '../../interfaces'
import {conceptResultTemplate} from '../helpers/concept_result_template'
import {checkForMatches} from '../helpers/checkForMatches';
import {exactMatch} from '../matchers/exact_match';
import {caseInsensitiveChecker} from '../matchers/case_insensitive_match'
import {blankByBlankMatch} from '../matchers/blank_by_blank_match'

export function checkFillInTheBlankQuestion(
  question_uid: string,
  response: string,
  responses: Array<Response>,
  caseInsensitive: boolean=false,
  defaultConceptUID: string|null,
  isDiagnosticFIB: boolean=false,
  blankByBlankGrading: BlankByBlankGrading,
  inputVals: string[],
  maxAttempts: number=null
): Response {
  const data = {
    response: response.trim().replace(/\s{2,}/g, ' '),
    responses,
    caseInsensitive,
    isDiagnosticFIB,
    blankByBlankGrading,
    inputVals,
    maxAttempts,
  }
  const responseTemplate = {
    text: data.response,
    question_uid,
    count: 1,
    concept_results: defaultConceptUID ? [conceptResultTemplate(defaultConceptUID)] : []
  };
  const firstPass = checkForMatches(data, firstPassMatchers)

  if (firstPass) {
    return Object.assign(responseTemplate, firstPass)
  }

  return responseTemplate;
}

function* firstPassMatchers(data: {
  response: string;
  responses: Array<Response>;
  caseInsensitive: boolean;
  isDiagnosticFIB: boolean;
  blankByBlankGrading: BlankByBlankGrading;
  inputVals: string[];
  maxAttempts: number;
}) {
  const {response, responses, caseInsensitive, isDiagnosticFIB, blankByBlankGrading, inputVals, maxAttempts, } = data;
  const submission = response
  yield exactMatch(submission, responses)

  if (blankByBlankGrading) {
    if (maxAttempts > 1 || !caseInsensitive) {
      yield caseInsensitiveChecker(submission, responses, true, caseInsensitive, isDiagnosticFIB)
    }

    yield blankByBlankMatch(blankByBlankGrading, submission, inputVals, caseInsensitive, maxAttempts)
  } else {
    yield caseInsensitiveChecker(submission, responses, true, caseInsensitive, isDiagnosticFIB)
  }
}
